/**
 * This file was @generated using pocketbase-typegen
 */

export enum Collections {
  AboutTranslators = 'about_translators',
  AnnualReports = 'annual_reports',
  BibleBooks = 'bible_books',
  BibleBooksFixed = 'bible_books_fixed',
  BibleChangelog = 'bible_changelog',
  BibleChapters = 'bible_chapters',
  BibleFiles = 'bible_files',
  BibleGroups = 'bible_groups',
  BibleNotes = 'bible_notes',
  BiblePersonalNotes = 'bible_personal_notes',
  BibleScrapes = 'bible_scrapes',
  BibleTexts = 'bible_texts',
  BibleTitles = 'bible_titles',
  BibleVerses = 'bible_verses',
  DailyQuote = 'daily_quote',
  DailyQuoteHistory = 'daily_quote_history',
  DailyQuoteRegistration = 'daily_quote_registration',
  Donations = 'donations',
  DonationsConfirmations = 'donations_confirmations',
  DonationsPledges = 'donations_pledges',
  Files = 'files',
  GlobalValues = 'global_values',
  IgnoredDonationEmails = 'ignored_donation_emails',
  Images = 'images',
  Langs = 'langs',
  NewsletterRegistration = 'newsletter_registration',
  PremiumFiles = 'premium_files',
  ReferenceGroups = 'reference_groups',
  ReferenceItems = 'reference_items',
  Reviews = 'reviews',
  SecretValues = 'secret_values',
  Translations = 'translations',
  UserNotes = 'user_notes',
  Users = 'users'
}

// Alias types for improved usability
export type IsoDateString = string;
export type RecordIdString = string;
export type HTMLString = string;

// System fields
export type BaseSystemFields<T = never> = {
  id: RecordIdString;
  created: IsoDateString;
  updated: IsoDateString;
  collectionId: string;
  collectionName: Collections;
  expand?: T;
};

export type AuthSystemFields<T = never> = {
  email: string;
  emailVisibility: boolean;
  username: string;
  verified: boolean;
} & BaseSystemFields<T>;

// Record types for each collection

export enum AboutTranslatorsPageOptions {
  'about' = 'about',
  'en' = 'en'
}
export type AboutTranslatorsRecord = {
  caption: string;
  image: string;
  name: string;
  order: number;
  page: AboutTranslatorsPageOptions;
  text: string;
};

export type AnnualReportsRecord = {
  file: string;
  year: number;
};

export type BibleBooksRecord = {
  book?: RecordIdString;
  name: string;
  scrape: RecordIdString;
};

export type BibleBooksFixedRecord = {
  b21_short: string;
  cz_long?: string;
  cz_name: string;
  cz_regex: string;
  cz_short: string;
  en_name: string;
  en_short: string;
  group: RecordIdString;
  osis: string;
  position: number;
  slug: string;
};

export type BibleChangelogRecord = {
  bible_note?: RecordIdString;
  bible_text?: RecordIdString;
  bible_title?: RecordIdString;
  editor: RecordIdString;
  text_original?: string;
  text_updated?: string;
};

export type BibleChaptersRecord = {
  audio?: string;
  book: RecordIdString;
  chapter?: number;
  position: number;
  video?: string;
};

export type BibleFilesRecord = {
  osis?: string;
  usfm?: string[];
};

export type BibleGroupsRecord = {
  cs_name: string;
  en_name: string;
  position?: number;
  video?: string;
};

export type BibleNotesRecord = {
  position: number;
  text?: string;
  verse?: RecordIdString;
};

export type BiblePersonalNotesRecord = {
  book: RecordIdString;
  text: string;
  user: RecordIdString;
  verse: string;
};

export type BibleScrapesRecord = {
  active?: boolean;
};

export type BibleTextsRecord = {
  chapter?: RecordIdString;
  position: number;
  text?: string;
  text_lowercase?: string;
  verse?: RecordIdString;
};

export enum BibleTitlesTypeOptions {
  'sub' = 'sub',
  'acrostic' = 'acrostic'
}
export type BibleTitlesRecord = {
  book?: RecordIdString;
  chapters?: RecordIdString;
  position: number;
  text: string;
  type?: BibleTitlesTypeOptions;
  verses?: RecordIdString;
};

export type BibleVersesRecord = {
  chapter?: RecordIdString;
  name: string;
  position: number;
};

export type DailyQuoteRecord = {
  active?: boolean;
  link?: string;
  position: number;
  text: string;
};

export type DailyQuoteHistoryRecord = {
  date: IsoDateString;
  link?: string;
  position: number;
  text: string;
};

export type DailyQuoteRegistrationRecord = {
  active?: boolean;
  email: string;
  token: string;
};

export type DonationsRecord = {
  accountNumber?: string;
  amount?: number;
  currency?: string;
  date?: IsoDateString;
  message?: string;
  name?: string;
  pledge: RecordIdString;
};

export type DonationsConfirmationsRecord = {
  pdf: string;
  user: RecordIdString;
  year: number;
};

export type DonationsPledgesRecord = {
  amount: number;
  biggestDonation?: number;
  lastDonation?: IsoDateString;
  totalReceived?: number;
  user: RecordIdString;
  variableSymbol: number;
};

export type FilesRecord = {
  expires?: IsoDateString;
  file?: string;
  name?: string;
};

export type GlobalValuesRecord = {
  key: string;
  private?: boolean;
  value: string;
};

export type IgnoredDonationEmailsRecord = {
  imap_id: number;
  reason?: string;
};

export type ImagesRecord = {
  image: string;
  slug: string;
};

export type LangsRecord = {
  localized: string;
  name: string;
  name_long: string;
};

export type NewsletterRegistrationRecord = {
  active?: boolean;
  email: string;
  token: string;
};

export type PremiumFilesRecord = {
  file: string;
  name: string;
  order: number;
};

export enum ReferenceGroupsPageOptions {
  'references' = 'references',
  'en' = 'en'
}
export type ReferenceGroupsRecord = {
  order: number;
  page: ReferenceGroupsPageOptions;
  references: RecordIdString[];
  title: string;
};

export type ReferenceItemsRecord = {
  image?: string;
  order: number;
  title: string;
  url: string;
};

export enum ReviewsPageOptions {
  'about' = 'about',
  'en' = 'en'
}
export type ReviewsRecord = {
  caption: string;
  name: string;
  order: number;
  page: ReviewsPageOptions;
  text: string;
};

export type SecretValuesRecord = {
  key: string;
  value?: string;
};

export type TranslationsRecord = {
  editable?: boolean;
  key: string;
  lang: RecordIdString;
  text: HTMLString;
};

export type UserNotesRecord = {
  note: string;
  user: RecordIdString;
};

export enum UsersRolesOptions {
  'super admin' = 'super admin',
  'admin' = 'admin',
  'developer' = 'developer',
  'user' = 'user'
}
export type UsersRecord<Tsettings = unknown> = {
  address?: string;
  avatar?: string;
  name?: string;
  onboarding?: boolean;
  phone?: string;
  roles?: UsersRolesOptions;
  settings?: null | Tsettings;
  surname?: string;
};

// Response types include system fields and match responses from the PocketBase API
export type AboutTranslatorsResponse<Texpand = unknown> = Required<AboutTranslatorsRecord> &
  BaseSystemFields<Texpand>;
export type AnnualReportsResponse<Texpand = unknown> = Required<AnnualReportsRecord> &
  BaseSystemFields<Texpand>;
export type BibleBooksResponse<Texpand = unknown> = Required<BibleBooksRecord> &
  BaseSystemFields<Texpand>;
export type BibleBooksFixedResponse<Texpand = unknown> = Required<BibleBooksFixedRecord> &
  BaseSystemFields<Texpand>;
export type BibleChangelogResponse<Texpand = unknown> = Required<BibleChangelogRecord> &
  BaseSystemFields<Texpand>;
export type BibleChaptersResponse<Texpand = unknown> = Required<BibleChaptersRecord> &
  BaseSystemFields<Texpand>;
export type BibleFilesResponse<Texpand = unknown> = Required<BibleFilesRecord> &
  BaseSystemFields<Texpand>;
export type BibleGroupsResponse<Texpand = unknown> = Required<BibleGroupsRecord> &
  BaseSystemFields<Texpand>;
export type BibleNotesResponse<Texpand = unknown> = Required<BibleNotesRecord> &
  BaseSystemFields<Texpand>;
export type BiblePersonalNotesResponse<Texpand = unknown> = Required<BiblePersonalNotesRecord> &
  BaseSystemFields<Texpand>;
export type BibleScrapesResponse<Texpand = unknown> = Required<BibleScrapesRecord> &
  BaseSystemFields<Texpand>;
export type BibleTextsResponse<Texpand = unknown> = Required<BibleTextsRecord> &
  BaseSystemFields<Texpand>;
export type BibleTitlesResponse<Texpand = unknown> = Required<BibleTitlesRecord> &
  BaseSystemFields<Texpand>;
export type BibleVersesResponse<Texpand = unknown> = Required<BibleVersesRecord> &
  BaseSystemFields<Texpand>;
export type DailyQuoteResponse<Texpand = unknown> = Required<DailyQuoteRecord> &
  BaseSystemFields<Texpand>;
export type DailyQuoteHistoryResponse<Texpand = unknown> = Required<DailyQuoteHistoryRecord> &
  BaseSystemFields<Texpand>;
export type DailyQuoteRegistrationResponse<Texpand = unknown> =
  Required<DailyQuoteRegistrationRecord> & BaseSystemFields<Texpand>;
export type DonationsResponse<Texpand = unknown> = Required<DonationsRecord> &
  BaseSystemFields<Texpand>;
export type DonationsConfirmationsResponse<Texpand = unknown> =
  Required<DonationsConfirmationsRecord> & BaseSystemFields<Texpand>;
export type DonationsPledgesResponse<Texpand = unknown> = Required<DonationsPledgesRecord> &
  BaseSystemFields<Texpand>;
export type FilesResponse<Texpand = unknown> = Required<FilesRecord> & BaseSystemFields<Texpand>;
export type GlobalValuesResponse<Texpand = unknown> = Required<GlobalValuesRecord> &
  BaseSystemFields<Texpand>;
export type IgnoredDonationEmailsResponse<Texpand = unknown> =
  Required<IgnoredDonationEmailsRecord> & BaseSystemFields<Texpand>;
export type ImagesResponse<Texpand = unknown> = Required<ImagesRecord> & BaseSystemFields<Texpand>;
export type LangsResponse<Texpand = unknown> = Required<LangsRecord> & BaseSystemFields<Texpand>;
export type NewsletterRegistrationResponse<Texpand = unknown> =
  Required<NewsletterRegistrationRecord> & BaseSystemFields<Texpand>;
export type PremiumFilesResponse<Texpand = unknown> = Required<PremiumFilesRecord> &
  BaseSystemFields<Texpand>;
export type ReferenceGroupsResponse<Texpand = unknown> = Required<ReferenceGroupsRecord> &
  BaseSystemFields<Texpand>;
export type ReferenceItemsResponse<Texpand = unknown> = Required<ReferenceItemsRecord> &
  BaseSystemFields<Texpand>;
export type ReviewsResponse<Texpand = unknown> = Required<ReviewsRecord> &
  BaseSystemFields<Texpand>;
export type SecretValuesResponse<Texpand = unknown> = Required<SecretValuesRecord> &
  BaseSystemFields<Texpand>;
export type TranslationsResponse<Texpand = unknown> = Required<TranslationsRecord> &
  BaseSystemFields<Texpand>;
export type UserNotesResponse<Texpand = unknown> = Required<UserNotesRecord> &
  BaseSystemFields<Texpand>;
export type UsersResponse<Tsettings = unknown, Texpand = unknown> = Required<
  UsersRecord<Tsettings>
> &
  AuthSystemFields<Texpand>;

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
  about_translators: AboutTranslatorsRecord;
  annual_reports: AnnualReportsRecord;
  bible_books: BibleBooksRecord;
  bible_books_fixed: BibleBooksFixedRecord;
  bible_changelog: BibleChangelogRecord;
  bible_chapters: BibleChaptersRecord;
  bible_files: BibleFilesRecord;
  bible_groups: BibleGroupsRecord;
  bible_notes: BibleNotesRecord;
  bible_personal_notes: BiblePersonalNotesRecord;
  bible_scrapes: BibleScrapesRecord;
  bible_texts: BibleTextsRecord;
  bible_titles: BibleTitlesRecord;
  bible_verses: BibleVersesRecord;
  daily_quote: DailyQuoteRecord;
  daily_quote_history: DailyQuoteHistoryRecord;
  daily_quote_registration: DailyQuoteRegistrationRecord;
  donations: DonationsRecord;
  donations_confirmations: DonationsConfirmationsRecord;
  donations_pledges: DonationsPledgesRecord;
  files: FilesRecord;
  global_values: GlobalValuesRecord;
  ignored_donation_emails: IgnoredDonationEmailsRecord;
  images: ImagesRecord;
  langs: LangsRecord;
  newsletter_registration: NewsletterRegistrationRecord;
  premium_files: PremiumFilesRecord;
  reference_groups: ReferenceGroupsRecord;
  reference_items: ReferenceItemsRecord;
  reviews: ReviewsRecord;
  secret_values: SecretValuesRecord;
  translations: TranslationsRecord;
  user_notes: UserNotesRecord;
  users: UsersRecord;
};

export type CollectionResponses = {
  about_translators: AboutTranslatorsResponse;
  annual_reports: AnnualReportsResponse;
  bible_books: BibleBooksResponse;
  bible_books_fixed: BibleBooksFixedResponse;
  bible_changelog: BibleChangelogResponse;
  bible_chapters: BibleChaptersResponse;
  bible_files: BibleFilesResponse;
  bible_groups: BibleGroupsResponse;
  bible_notes: BibleNotesResponse;
  bible_personal_notes: BiblePersonalNotesResponse;
  bible_scrapes: BibleScrapesResponse;
  bible_texts: BibleTextsResponse;
  bible_titles: BibleTitlesResponse;
  bible_verses: BibleVersesResponse;
  daily_quote: DailyQuoteResponse;
  daily_quote_history: DailyQuoteHistoryResponse;
  daily_quote_registration: DailyQuoteRegistrationResponse;
  donations: DonationsResponse;
  donations_confirmations: DonationsConfirmationsResponse;
  donations_pledges: DonationsPledgesResponse;
  files: FilesResponse;
  global_values: GlobalValuesResponse;
  ignored_donation_emails: IgnoredDonationEmailsResponse;
  images: ImagesResponse;
  langs: LangsResponse;
  newsletter_registration: NewsletterRegistrationResponse;
  premium_files: PremiumFilesResponse;
  reference_groups: ReferenceGroupsResponse;
  reference_items: ReferenceItemsResponse;
  reviews: ReviewsResponse;
  secret_values: SecretValuesResponse;
  translations: TranslationsResponse;
  user_notes: UserNotesResponse;
  users: UsersResponse;
};
